var React = require('react');

function IcCart (props) {
    return React.createElement("svg",props,React.createElement("path",{"d":"m90.59 37.219h-15.078l-10.203-21.688c-0.23828-0.48828-0.82812-0.69531-1.3203-0.46484-0.49219 0.23047-0.71094 0.81641-0.48828 1.3125l9.8008 20.828-46.602 0.003907 9.8008-20.828v-0.003906c0.22266-0.49609 0.003906-1.082-0.48828-1.3125-0.49219-0.23047-1.082-0.023437-1.3203 0.46484l-10.203 21.688h-15.078c-0.32031-0.011719-0.625 0.12891-0.82422 0.38281-0.19531 0.25-0.26172 0.58203-0.17578 0.88672l10.648 37.121c1.6289 5.5547 6.7148 9.375 12.5 9.3906h36.883c5.7969-0.019531 10.887-3.8594 12.5-9.4297l10.609-37.082c0.085938-0.30469 0.019531-0.63672-0.17969-0.88672-0.19531-0.25391-0.5-0.39453-0.82031-0.38281zm-11.59 37.852c-1.3398 4.7305-5.6602 8-10.578 8h-36.863c-4.918 0-9.2383-3.2695-10.578-8l-10.242-35.852h78.523z"}));
}

IcCart.defaultProps = {"width":"100pt","height":"100pt","version":"1.1","viewBox":"0 0 100 100"};

module.exports = IcCart;

IcCart.default = IcCart;
